import { useSelector } from 'react-redux';
import { FDealType } from '../../../packages/JsonQuery';
import { useFilterChangeCallback, useShowSearchMetaTooltip } from 'shared/hooks';
import { FC, useCallback } from 'react';
import { PostfixPopupLink } from 'shared/components/PostfixPopupLink';
import { OPTIONS } from './constants';
import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { selectDealTypeFilter } from 'shared/selectors/filters';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { trackQuickFilterClick } from 'shared/utils/analytics';

const FILTER_KEY = 'dealType';

export const DealTypeContainer: FC = () => {
  const { label, value } = useSelector(selectDealTypeFilter);

  const { opened, onOpen, onClose } = useDropdown(FILTER_KEY);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (dealType: FDealType) => {
      onChange({ action: 'setDealType', arguments: [dealType] });
      onClose();
    },
    [onChange, onClose],
  );

  const handleOpen = useCallback(() => {
    trackQuickFilterClick('deal_type');
    onOpen();
  }, [onOpen]);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      opened={opened}
      showTooltip={showTooltip}
      onOpen={handleOpen}
      onClose={onClose}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <DropdownSelect
          value={value}
          options={OPTIONS}
          postfix={
            <PostfixPopupLink
              href="/country-builders-projects/?utm_medium=listing&utm_content=link"
              text="Построить дом"
            />
          }
          onChange={handleChange}
        />
      }
    />
  );
};
